let slickFirstClientX = 0;
// let slickFirstClientY = 0;

const preventTouch = (e) =>{
  const minValue = 15;

  const clientX = e.touches[0].clientX - slickFirstClientX;
  // const clientY = e.touches[0].clientY - slickFirstClientY;

  if(Math.abs(clientX) > minValue){
    if (!e.cancelable) return true;
    e.preventDefault();
    e.returnValue = false;
    return false;
  }
};

const touchStart = (e) => {
  slickFirstClientX = e.touches[0].clientX;
  // slickFirstClientY = e.touches[0].clientY;
};

const fixSlickVerticalBug = () => {
  const slickSliders = document.querySelectorAll(".slick-slider");

  slickSliders.forEach((_slider) => {
    const hasFix = _slider.getAttribute("with-vertical-fix");
    if (hasFix) return;

    _slider.addEventListener("touchstart", touchStart);
    _slider.addEventListener("touchmove", preventTouch, { passive: false });

    _slider.setAttribute("with-vertical-fix", true);
  });
};

export default fixSlickVerticalBug;
